<template>
  <PageLayoutWrapper page="search">
    <GlobalSearch v-if="enableGlobalSearch" />
    <GlobalSearchLegacy v-else />
  </PageLayoutWrapper>
</template>

<script>
import { mapState } from 'vuex'
import GlobalSearch from '@/components/GlobalSearch'
import GlobalSearchLegacy from '@/components/GlobalSearchLegacy'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { GLOBAL_SEARCH } from '@/constants/featureFlags'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import pageLayout from '@/mixins/pageLayoutMixin'

export default {
  components: {
    GlobalSearch,
    GlobalSearchLegacy,
    PageLayoutWrapper,
  },
  mixins: [pageLayout],
  setup() {
    const { enableGlobalSearch } = useFeatureFlags({
      enableGlobalSearch: GLOBAL_SEARCH,
    })
    return { enableGlobalSearch }
  },
  head() {
    return {
      title: `${this.schoolDisplayName} Catalog: Search`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Search catalog',
        },
      ],
    }
  },
  computed: {
    ...mapState('settings', ['schoolDisplayName']),
  },
}
</script>
